import { NgModule } from '@angular/core';
import { ColumnComponent } from './components/column/column.component';
import { TableComponent } from './components/table/table.component';
import { VirtualizedTableComponent } from './components/virtualized-table/virtualized-table.component';
import {
  ClipboardDirective,
  ColumnHeaderDirective,
  ColumnTemplateDirective,
  DragDirective,
  DropDirective,
  FilterDirective,
  MultiExpansionDirective,
  PaginatorDirective,
  SelectionDirective,
  SortDirective,
  SpxRowDirective,
} from './directives';

@NgModule({
  imports: [
    TableComponent,
    VirtualizedTableComponent,
    ColumnComponent,
    ClipboardDirective,
    FilterDirective,
    PaginatorDirective,
    SelectionDirective,
    SpxRowDirective,
    MultiExpansionDirective,
    ColumnHeaderDirective,
    ColumnTemplateDirective,
    DragDirective,
    DropDirective,
    SortDirective,
  ],
  exports: [
    TableComponent,
    VirtualizedTableComponent,
    ColumnComponent,
    ClipboardDirective,
    FilterDirective,
    PaginatorDirective,
    SelectionDirective,
    MultiExpansionDirective,
    ColumnHeaderDirective,
    ColumnTemplateDirective,
    DragDirective,
    DropDirective,
    SortDirective,
  ],
})
export class TableModule {}
